import {InitPage} from "../index";

declare var reorderModesPath: string;
declare var isViewOnly: boolean;

interface ModeData {
    id: number;
    mode: number;
    title: string;
    max_order_count: number;
    max_order_qty: number;
    deletable: boolean;
    enable_auto_firm: boolean;
    zone_ids: number[];
    cart_zone_ids: number[];
    shipped_sub_zone_id?: number | null;
}

interface ApiResponse {
    success: boolean;
    message: string;
}

class WOPModes {
    private modeForm: JQuery<HTMLFormElement>;
    private modeModal: JQuery<HTMLElement>;
    private modeTable: JQuery<HTMLElement>;
    private modeIdInput: JQuery<HTMLInputElement>;
    private modeInput: JQuery<HTMLInputElement>;
    private titleInput: JQuery<HTMLInputElement>;
    private maxOrderCountInput: JQuery<HTMLInputElement>;
    private maxOrderQtyInput: JQuery<HTMLInputElement>;
    private enableAutoFirmCheckbox: JQuery<HTMLInputElement>;
    private zoneIdsSelect: JQuery<HTMLElement>;
    private cartZoneIdsSelect: JQuery<HTMLElement>;
    private shippedSubZoneIdSelect: JQuery<HTMLElement>;

    constructor() {
        this.initializeElements();
        this.bindEvents();
        if (!isViewOnly) {
            this.initializeSortable();
        }
    }

    private initializeElements(): void {
        this.modeForm = $("#mode-form");
        this.modeModal = $("#mode-modal");
        this.modeTable = $("#mode-table");
        this.modeIdInput = $("#mode_id");
        this.modeInput = $('input[name="mode"]');
        this.titleInput = $('input[name="title"]');
        this.maxOrderCountInput = $('input[name="max_order_count"]');
        this.maxOrderQtyInput = $('input[name="max_order_qty"]');
        this.enableAutoFirmCheckbox = $("#enable_auto_firm");
        this.zoneIdsSelect = $("#zone_ids");
        this.cartZoneIdsSelect = $("#cart_zone_ids");
        this.shippedSubZoneIdSelect = $("#shipped_sub_zone_id");
    }

    private bindEvents(): void {
        $(document).on("click", ".edit-mode", (e: JQuery.ClickEvent) => this.handleEditClick(e));
        $(document).on("ajax:success", "#mode-form", (event: JQuery.TriggeredEvent, data: ApiResponse) => this.handleFormSuccess(data));
        $(document).on("ajax:error", "#mode-form", (event: JQuery.TriggeredEvent, xhr: JQuery.jqXHR) => this.handleFormError(xhr));
        this.modeModal.on("shown.bs.modal", () => this.handleModalShown());
    }

    private handleEditClick(e: JQuery.ClickEvent): void {
        e.preventDefault();
        const modeData: ModeData = $(e.currentTarget).data("mode") as ModeData;
        const updateUrl = this.buildUpdateUrl(modeData.id);

        this.modeForm.attr("action", updateUrl);
        this.ensureMethodOverride();
        this.populateForm(modeData);
        this.initializeSelect2();
        this.modeModal.modal("show");
    }

    private buildUpdateUrl(modeId: number): string {
        const basePath = this.modeForm.data("update-path-base") || "";
        return basePath.replace("MODE_ID", modeId.toString());
    }

    private ensureMethodOverride(): void {
        if (this.modeForm.find('input[name="_method"]').length === 0) {
            this.modeForm.append('<input type="hidden" name="_method" value="patch">');
        }
    }

    private populateForm(mode: ModeData): void {
        this.modeIdInput.val(mode.id);
        this.modeInput.val(mode.mode).prop("disabled", !mode.deletable).prop("readonly", !mode.deletable);
        this.titleInput.val(mode.title);
        this.maxOrderCountInput.val(mode.max_order_count);
        this.maxOrderQtyInput.val(mode.max_order_qty);
        
        const enableAutoFirmValue: any = mode.enable_auto_firm;
        const enableAutoFirm = enableAutoFirmValue === true || 
                               enableAutoFirmValue === "true" || 
                               enableAutoFirmValue === 1 ||
                               enableAutoFirmValue === "1";
        this.enableAutoFirmCheckbox.prop("checked", enableAutoFirm);
        
        this.zoneIdsSelect.val((mode.zone_ids || []).map((id: number) => id.toString()));
        this.cartZoneIdsSelect.val((mode.cart_zone_ids || []).map((id: number) => id.toString()));
        this.shippedSubZoneIdSelect.val(mode.shipped_sub_zone_id ? mode.shipped_sub_zone_id.toString() : '');
    }

    private initializeSelect2(): void {
        // Initialize zone_ids select2 if not already initialized
        if (!this.zoneIdsSelect.hasClass("select2-hidden-accessible")) {
            (this.zoneIdsSelect as any).select2({ width: "100%" });
        }
        // Initialize cart_zone_ids select2 if not already initialized
        if (!this.cartZoneIdsSelect.hasClass("select2-hidden-accessible")) {
            (this.cartZoneIdsSelect as any).select2({ width: "100%" });
        }
        // Initialize shipped_sub_zone_id select2 if not already initialized
        if (!this.shippedSubZoneIdSelect.hasClass("select2-hidden-accessible")) {
            (this.shippedSubZoneIdSelect as any).select2({ 
                width: "100%",
                dropdownParent: this.modeModal
            });
        }
    }

    private handleModalShown(): void {
        // Re-initialize element references in case they changed
        this.zoneIdsSelect = $("#zone_ids");
        this.cartZoneIdsSelect = $("#cart_zone_ids");
        this.shippedSubZoneIdSelect = $("#shipped_sub_zone_id");
        // Initialize Select2 for all selects when modal is shown
        this.initializeSelect2();
    }

    private handleFormSuccess(data: ApiResponse): void {
        this.modeModal.modal("hide");
        setTimeout(() => {
            this.reloadModesSection();
            this.showToast(data.success, data.message);
        }, 500);
    }

    private handleFormError(xhr: JQuery.jqXHR): void {
        const data: ApiResponse = xhr.responseJSON || {};
        const message = data.message || "An error occurred";
        this.showToast(false, message);
    }

    private reloadModesSection(): void {
        const _this = this;
        $("#wave-orders-modes").load(window.location.href + " #wave-orders-modes > *", function() {
            // Reinitialize element references after content is loaded
            _this.modeTable = $("#mode-table");
            _this.modeForm = $("#mode-form");
            _this.modeModal = $("#mode-modal");
            _this.modeIdInput = $("#mode_id");
            _this.modeInput = $('input[name="mode"]');
            _this.titleInput = $('input[name="title"]');
            _this.maxOrderCountInput = $('input[name="max_order_count"]');
            _this.maxOrderQtyInput = $('input[name="max_order_qty"]');
            _this.enableAutoFirmCheckbox = $("#enable_auto_firm");
            _this.zoneIdsSelect = $("#zone_ids");
            _this.cartZoneIdsSelect = $("#cart_zone_ids");
            _this.shippedSubZoneIdSelect = $("#shipped_sub_zone_id");
            // Reinitialize sortable after content is loaded (only if not view only)
            if (!isViewOnly) {
                _this.initializeSortable();
            }
            // Update reorderModesPath in case it changed
            const scriptTag = $("#wave-orders-modes script");
            if (scriptTag.length > 0) {
                const scriptContent = scriptTag.html();
                const match = scriptContent.match(/var reorderModesPath = "([^"]+)"/);
                if (match && match[1]) {
                    (window as any).reorderModesPath = match[1];
                }
            }
        });
    }

    private showToast(success: boolean, message: string): void {
        if (success) {
            window.toastr_notifications.success(message, "");
        } else {
            window.toastr_notifications.error(message, "");
        }
    }

    private initializeSortable(): void {
        // Destroy existing sortable if it exists
        if (this.modeTable.hasClass("ui-sortable")) {
            this.modeTable.sortable("destroy");
        }
        this.modeTable.sortable({
            items: "tr.center-content",
            update: () => this.handleSortableUpdate()
        });
    }

    private handleSortableUpdate(): void {
        const ids = this.modeTable.sortable("toArray")
            .map((id: string) => id.replace("order-", ""))
            .filter((item: string) => !!item);

        $.ajax({
            type: "POST",
            data: { ids: ids },
            url: reorderModesPath
        });
    }
}

declare global {
    interface Window {
        WOPModes: WOPModes;
    }
}

export function LoadPage(): void {
    InitPage("wop settings", () => {
        const wopModes = new WOPModes();
        window.WOPModes = wopModes;
    });
}

